import { Feature, FeatureToggleConfig } from '@shopee-user/feature-toggle';

export const GENERAL_BASE_CONFIG: Pick<
  FeatureToggleConfig,
  | Feature.HideContactBusinessPartnerInDialog
  | Feature.ForceCenterTextInOtpErrorDialog
  | Feature.CallCheckPasswordMigrateApi
  | Feature.LoginHideSignupButton
  | Feature.LoginTermsOfService
  | Feature.HomepageRedirection
  | Feature.ShowPoweredByShopeeText
  | Feature.EnableLoginTimeout
  | Feature.ValidateAuthenticationRedirectionConfig
  | Feature.SupportZaloOtp
  | Feature.SupportViberOtp
  | Feature.WebTracking
  | Feature.AppTracking
  | Feature.LanguageSelector
  | Feature.AccountSuspendedUseHelpCenterLink
  | Feature.HideShopeeLogo
> = {
  [Feature.HideContactBusinessPartnerInDialog]: false,
  [Feature.ForceCenterTextInOtpErrorDialog]: false,
  [Feature.CallCheckPasswordMigrateApi]: false,
  [Feature.LoginHideSignupButton]: false,
  [Feature.LoginTermsOfService]: false,
  [Feature.HomepageRedirection]: false,
  [Feature.ShowPoweredByShopeeText]: false,
  [Feature.EnableLoginTimeout]: false,
  [Feature.ValidateAuthenticationRedirectionConfig]: false,
  [Feature.SupportZaloOtp]: true,
  [Feature.SupportViberOtp]: false,
  [Feature.WebTracking]: false,
  [Feature.AppTracking]: false,
  [Feature.LanguageSelector]: false,
  [Feature.AccountSuspendedUseHelpCenterLink]: false,
  [Feature.HideShopeeLogo]: false,
};

export const LOGIN_BY_PASSWORD_BASE_CONFIG: Pick<
  FeatureToggleConfig,
  | Feature.LoginByPasswordEntrance
  | Feature.LoginByPasswordAllowEmail
  | Feature.LoginByPasswordAllowPhone
  | Feature.LoginByPasswordRestrictPasswordLength
  | Feature.LoginByPasswordNewUserHint
  | Feature.LoginByPasswordCheckPasswordExistApi
  | Feature.LoginByPasswordShowResetPasswordLinkInSmallDevice
  | Feature.LoginByPasswordSetNewPasswordOnInitialLogin
  | Feature.LoginByPasswordSkipShopeeAccountConfirmation
  | Feature.LoginByPasswordLayoutRefactor
  | Feature.LoginByPasswordOneCredentialLayoutRefactor
  | Feature.LoginByPasswordShowLoginTip
> = {
  [Feature.LoginByPasswordEntrance]: false,
  [Feature.LoginByPasswordAllowEmail]: false,
  [Feature.LoginByPasswordAllowPhone]: false,
  [Feature.LoginByPasswordRestrictPasswordLength]: false,
  [Feature.LoginByPasswordNewUserHint]: false,
  [Feature.LoginByPasswordCheckPasswordExistApi]: false,
  [Feature.LoginByPasswordShowResetPasswordLinkInSmallDevice]: false,
  [Feature.LoginByPasswordSetNewPasswordOnInitialLogin]: false,
  [Feature.LoginByPasswordSkipShopeeAccountConfirmation]: false,
  [Feature.LoginByPasswordLayoutRefactor]: false,
  [Feature.LoginByPasswordOneCredentialLayoutRefactor]: false,
  [Feature.LoginByPasswordShowLoginTip]: false,
};

export const LOGIN_BY_OTP_BASE_CONFIG: Pick<
  FeatureToggleConfig,
  | Feature.LoginByOtpEntrance
  | Feature.LoginByOtpAllowEmail
  | Feature.LoginByOtpAllowPhone
  | Feature.LoginByOtpNotRegisteredRedirectToSignup
  | Feature.LoginByOtpSupportWAL
> = {
  [Feature.LoginByOtpEntrance]: false,
  [Feature.LoginByOtpAllowEmail]: false,
  [Feature.LoginByOtpAllowPhone]: false,
  [Feature.LoginByOtpNotRegisteredRedirectToSignup]: false,
  [Feature.LoginByOtpSupportWAL]: false,
};

export const LOGIN_BY_BIOMETRIC_BASE_CONFIG: Pick<
  FeatureToggleConfig,
  | Feature.BiometricsV1
  | Feature.BiometricsV2
  | Feature.LoginByBiometricsSupportWAL
  | Feature.LoginByBiometricsEmailOtp
> = {
  [Feature.BiometricsV1]: false,
  [Feature.BiometricsV2]: false,
  [Feature.LoginByBiometricsSupportWAL]: false,
  [Feature.LoginByBiometricsEmailOtp]: false,
};

export const SIGNUP_BY_OTP_BASE_CONFIG: Pick<
  FeatureToggleConfig,
  | Feature.SignupByOtpEntrance
  | Feature.SignupByOtpEnableOneCredential
  | Feature.SignupByOtpAllowEmail
  | Feature.SignupByOtpAllowPhone
  | Feature.SignupByOtpRequireAcceptTermsAndService
  | Feature.SignupByOtpRequirePassword
  | Feature.SignupByOtpCustomiseResendOtpMessage
  | Feature.SignupByOtpLoginUponAlreadyRegisteredWithPhone
  | Feature.SignupByOtpLoginUponAlreadyRegisteredWithEmail
  | Feature.SignupByOtpHideSignupTip
  | Feature.SignupByOtpSkipAlreadyRegistered
  | Feature.SignupByOtpSkipSignupSuccess
  | Feature.SignupByOtpDisableReclaimPhone
  | Feature.SignupByOtpSupportWAL
  | Feature.SignupByOtpLayoutRefactor
> = {
  [Feature.SignupByOtpEntrance]: false,
  [Feature.SignupByOtpEnableOneCredential]: false,
  [Feature.SignupByOtpAllowEmail]: false,
  [Feature.SignupByOtpAllowPhone]: false,
  [Feature.SignupByOtpRequireAcceptTermsAndService]: false,
  [Feature.SignupByOtpRequirePassword]: false,
  [Feature.SignupByOtpCustomiseResendOtpMessage]: false,
  [Feature.SignupByOtpLoginUponAlreadyRegisteredWithPhone]: false,
  [Feature.SignupByOtpLoginUponAlreadyRegisteredWithEmail]: false,
  [Feature.SignupByOtpHideSignupTip]: false,
  [Feature.SignupByOtpSkipAlreadyRegistered]: false,
  [Feature.SignupByOtpSkipSignupSuccess]: false,
  [Feature.SignupByOtpDisableReclaimPhone]: false,
  [Feature.SignupByOtpSupportWAL]: false,
  [Feature.SignupByOtpLayoutRefactor]: false,
};

export const RESET_PASSWORD_BASE_CONFIG: Pick<
  FeatureToggleConfig,
  | Feature.ResetPasswordEntrance
  | Feature.ResetPasswordFromLinkEntrance
  | Feature.ResetPasswordShowHelpText
  | Feature.ResetPasswordByPhone
  | Feature.ResetPasswordByEmail
  | Feature.ResetPasswordCallResetPasswordInit
  | Feature.ResetPasswordSuccessCountdownPage
  | Feature.ResetPasswordHandledByBusinessPartner
  | Feature.ResetPasswordOnShopeeJumpToToC
  | Feature.ResetPasswordSupportWAL
> = {
  [Feature.ResetPasswordEntrance]: false,
  [Feature.ResetPasswordFromLinkEntrance]: false,
  [Feature.ResetPasswordShowHelpText]: false,
  [Feature.ResetPasswordByPhone]: false,
  [Feature.ResetPasswordByEmail]: false,
  [Feature.ResetPasswordCallResetPasswordInit]: false,
  [Feature.ResetPasswordSuccessCountdownPage]: false,
  [Feature.ResetPasswordHandledByBusinessPartner]: false,
  [Feature.ResetPasswordOnShopeeJumpToToC]: false,
  [Feature.ResetPasswordSupportWAL]: false,
};

export const SHOPEE_PAY_MIGRATION_BASE_CONFIG: Pick<
  FeatureToggleConfig,
  | Feature.ShopeePayLoginByPassword
  | Feature.ShopeePayChangePassword
  | Feature.LoginByPasswordRedirectToShopeePay
  | Feature.ShopeePayMigrationBanner
> = {
  [Feature.ShopeePayLoginByPassword]: false,
  [Feature.ShopeePayChangePassword]: false,
  [Feature.LoginByPasswordRedirectToShopeePay]: false,
  [Feature.ShopeePayMigrationBanner]: false,
};

export const SHOPEE_PARTNER_SPECIFIC_BASE_CONFIG: Pick<
  FeatureToggleConfig,
  | Feature.ShopeePartnerWeb
  | Feature.ShopeePartnerDesktopBackground
  | Feature.ShopeePartnerHashPassword
> = {
  [Feature.ShopeePartnerWeb]: false,
  [Feature.ShopeePartnerDesktopBackground]: false,
  [Feature.ShopeePartnerHashPassword]: false,
};

export const WEBVIEW_BASE_CONFIG: Pick<
  FeatureToggleConfig,
  | Feature.WebViewNotifyLoginError
  | Feature.WebViewLogoutAfterCredentialChange
  | Feature.OpenAccountDeleteLinkAsExternalUrl
  | Feature.OpenAccountDeleteIosLinkAsAppRL
  | Feature.OpenAccountDeleteAndroidLinkAsAppRL
  | Feature.NotifyRefreshToken
  | Feature.NotifyRefreshTokenLegacy
  | Feature.OpenSignupTipFormAsExternalUrl
  | Feature.WebViewLoginSuccessfullySendFromSource
  | Feature.WebViewNotifySignupSuccess
  | Feature.WebViewABTestSupported
> = {
  [Feature.WebViewNotifyLoginError]: false,
  [Feature.WebViewLogoutAfterCredentialChange]: false,
  [Feature.OpenAccountDeleteLinkAsExternalUrl]: false,
  [Feature.OpenAccountDeleteIosLinkAsAppRL]: false,
  [Feature.OpenAccountDeleteAndroidLinkAsAppRL]: false,
  [Feature.NotifyRefreshToken]: false,
  [Feature.NotifyRefreshTokenLegacy]: false,
  [Feature.OpenSignupTipFormAsExternalUrl]: false,
  [Feature.WebViewLoginSuccessfullySendFromSource]: false,
  [Feature.WebViewNotifySignupSuccess]: false,
  [Feature.WebViewABTestSupported]: false,
};

export const USER_ACCOUNT_BASE_CONFIG: Pick<
  FeatureToggleConfig,
  | Feature.UserAccountEntrance
  | Feature.UserManagePhoneNumber
  | Feature.UserManageEmail
  | Feature.UserManageUsername
  | Feature.UserManagePassword
  | Feature.UserManageToCPassword
  | Feature.UserAccountLinkage
  | Feature.UserShowToCPhoneInfo
  | Feature.UserShowToCHelpFooter
  | Feature.UserManageToCLinkedEmail
  | Feature.AdminManagePhoneNumber
  | Feature.AdminManageEmail
  | Feature.AdminManageUsername
  | Feature.AdminManagePassword
  | Feature.AccountDeleteEntranceIOS
  | Feature.AccountDeleteEntranceAndroid
  | Feature.UnmaskUserPhone
  | Feature.UnmaskUserEmail
  | Feature.UserCredentialsCommit
> = {
  [Feature.UserAccountEntrance]: false,
  [Feature.UserManagePhoneNumber]: false,
  [Feature.UserManageEmail]: false,
  [Feature.UserManageUsername]: false,
  [Feature.UserManagePassword]: false,
  [Feature.UserManageToCPassword]: false,
  [Feature.UserAccountLinkage]: false,
  [Feature.UserShowToCPhoneInfo]: false,
  [Feature.UserShowToCHelpFooter]: false,
  [Feature.UserManageToCLinkedEmail]: false,
  [Feature.AdminManagePhoneNumber]: false,
  [Feature.AdminManageEmail]: false,
  [Feature.AdminManageUsername]: false,
  [Feature.AdminManagePassword]: false,
  [Feature.AccountDeleteEntranceIOS]: false,
  [Feature.AccountDeleteEntranceAndroid]: false,
  [Feature.UnmaskUserPhone]: false,
  [Feature.UnmaskUserEmail]: false,
  [Feature.UserCredentialsCommit]: false,
};

export const USER_PHONE_BASE_CONFIG: Pick<
  FeatureToggleConfig,
  | Feature.UserPhoneEntrance
  | Feature.UserAddPhone
  | Feature.UserChangePhone
  | Feature.UserChangePhoneSupportWAL
  | Feature.CallChangePhoneInitApiInProfilePage
  | Feature.ChangePhoneUseNativeVerification
> = {
  [Feature.UserPhoneEntrance]: false,
  [Feature.UserAddPhone]: false,
  [Feature.UserChangePhone]: false,
  [Feature.UserChangePhoneSupportWAL]: false,
  [Feature.CallChangePhoneInitApiInProfilePage]: false,
  [Feature.ChangePhoneUseNativeVerification]: false,
};

export const USER_EMAIL_BASE_CONFIG: Pick<
  FeatureToggleConfig,
  | Feature.UserEmailEntrance
  | Feature.UserAddEmail
  | Feature.UserChangeEmail
  | Feature.CallChangeEmailInitApiInProfilePage
  | Feature.ChangeEmailUseNativeVerification
> = {
  [Feature.UserEmailEntrance]: false,
  [Feature.UserAddEmail]: false,
  [Feature.UserChangeEmail]: false,
  [Feature.CallChangeEmailInitApiInProfilePage]: false,
  [Feature.ChangeEmailUseNativeVerification]: false,
};

export const USER_PASSWORD_BASE_CONFIG: Pick<
  FeatureToggleConfig,
  | Feature.UserPasswordEntrance
  | Feature.UserPasswordForgetPrompt
  | Feature.UserPasswordWebLogoutAfterCredentialChange
  | Feature.CallChangePasswordInitApiInProfilePage
  | Feature.ChangePasswordUseNativeVerification
> = {
  [Feature.UserPasswordEntrance]: false,
  [Feature.UserPasswordForgetPrompt]: false,
  [Feature.UserPasswordWebLogoutAfterCredentialChange]: false,
  [Feature.CallChangePasswordInitApiInProfilePage]: false,
  [Feature.ChangePasswordUseNativeVerification]: false,
};

export const OTP_SHARED_SERVICE_BASE_CONFIG: Pick<
  FeatureToggleConfig,
  Feature.VerifyOtpSharedService
> = {
  [Feature.VerifyOtpSharedService]: false,
};

export const ONE_CREDENTIAL_BASE_CONFIG: Pick<
  FeatureToggleConfig,
  | Feature.OneCredential
  | Feature.OneCredentialAllowPhone
  | Feature.OneCredentialAllowEmail
  | Feature.OneCredentialSupportToBAccount
  | Feature.OneCredentialAcceptInvitation
  | Feature.OneCredentialLoginShowNoLinkedToBAccountError
  | Feature.OneCredentialShouldCreateToBAccount
  | Feature.OneCredentialSignupSkipCreateAccountPage
  | Feature.TobOneCredential
> = {
  [Feature.OneCredential]: false,
  [Feature.OneCredentialAllowPhone]: false,
  [Feature.OneCredentialAllowEmail]: false,
  [Feature.OneCredentialSupportToBAccount]: true,
  [Feature.OneCredentialAcceptInvitation]: false,
  [Feature.OneCredentialLoginShowNoLinkedToBAccountError]: false,
  [Feature.OneCredentialShouldCreateToBAccount]: false,
  [Feature.OneCredentialSignupSkipCreateAccountPage]: false,
  [Feature.TobOneCredential]: false,
};

export const ONE_CREDENTIAL_MIGRATION_BASE_CONFIG: Pick<
  FeatureToggleConfig,
  | Feature.OneCredentialMigrationEntrance
  | Feature.OneCredentialMigrationAllowStaffToChangePhoneAndEmail
  | Feature.OneCredentialMigrationDisallowNotifyAdmin
  | Feature.OneCredentialMigrationCallCheckAuthKeyAvailable
  | Feature.OneCredentialMigrationBypassOtp
  | Feature.OneCredentialMigrationNotifyMigrationSuccess
  | Feature.OneCredentialMigrationLinkingNoticePopup
  | Feature.OneCredentialMigrationSkipAccountUpdate
  | Feature.OneCredentialMigrationSupportWAL
> = {
  [Feature.OneCredentialMigrationEntrance]: false,
  [Feature.OneCredentialMigrationAllowStaffToChangePhoneAndEmail]: false,
  [Feature.OneCredentialMigrationDisallowNotifyAdmin]: false,
  [Feature.OneCredentialMigrationCallCheckAuthKeyAvailable]: false,
  [Feature.OneCredentialMigrationBypassOtp]: false,
  [Feature.OneCredentialMigrationNotifyMigrationSuccess]: false,
  [Feature.OneCredentialMigrationLinkingNoticePopup]: false,
  [Feature.OneCredentialMigrationSkipAccountUpdate]: false,
  [Feature.OneCredentialMigrationSupportWAL]: false,
};

export const ONE_CREDENTIAL_DELINK_BASE_CONFIG: Pick<
  FeatureToggleConfig,
  | Feature.OneCredentialOptional
  | Feature.OneCredentialDelinkEntrance
  | Feature.OneCredentialDelinkAllowPhone
  | Feature.OneCredentialDelinkAllowEmail
  | Feature.OneCredentialDelinkSetPasswordEnabled
  | Feature.OneCredentialDelinkSupportWAL
  | Feature.OneCredentialDelinkAllowUsername
> = {
  [Feature.OneCredentialOptional]: false,
  [Feature.OneCredentialDelinkEntrance]: false,
  [Feature.OneCredentialDelinkAllowPhone]: false,
  [Feature.OneCredentialDelinkAllowEmail]: false,
  [Feature.OneCredentialDelinkSetPasswordEnabled]: false,
  [Feature.OneCredentialDelinkSupportWAL]: false,
  [Feature.OneCredentialDelinkAllowUsername]: false,
};

export const ONE_CREDENTIAL_SWITCH_TOC_BASE_CONFIG: Pick<
  FeatureToggleConfig,
  | Feature.OneCredentialSwitchToCLinkAdminEnabled
  | Feature.OneCredentialSwitchToCLinkStaffEnabled
> = {
  [Feature.OneCredentialSwitchToCLinkAdminEnabled]: false,
  [Feature.OneCredentialSwitchToCLinkStaffEnabled]: false,
};

export const TOB_BRANDING_CONFIG: Pick<
  FeatureToggleConfig,
  Feature.SPXRebrandUI | Feature.SPXDebrandUI | Feature.SPXOrangeBackgroundUI
> = {
  [Feature.SPXRebrandUI]: false,
  [Feature.SPXDebrandUI]: false,
  [Feature.SPXOrangeBackgroundUI]: false,
};

export const THIRDPARTY_INTEGRATION_BASE_CONFIG: Pick<
  FeatureToggleConfig,
  | Feature.ThirdpartyIntegrationSupportShopeeInApp
  | Feature.ThirdpartyIntegrationSupportShopeeInWeb
  | Feature.ThirdpartyIntegrationSupportGoogleInApp
  | Feature.ThirdpartyIntegrationSupportGoogleInWeb
  | Feature.ThirdpartyIntegrationSupportFacebookInApp
  | Feature.ThirdpartyIntegrationSupportFacebookInWeb
  | Feature.ThirdpartyIntegrationSupportAppleInApp
  | Feature.ThirdpartyIntegrationSupportAppleInWeb
> = {
  [Feature.ThirdpartyIntegrationSupportShopeeInApp]: false,
  [Feature.ThirdpartyIntegrationSupportShopeeInWeb]: false,
  [Feature.ThirdpartyIntegrationSupportGoogleInApp]: false,
  [Feature.ThirdpartyIntegrationSupportGoogleInWeb]: false,
  [Feature.ThirdpartyIntegrationSupportFacebookInApp]: false,
  [Feature.ThirdpartyIntegrationSupportFacebookInWeb]: false,
  [Feature.ThirdpartyIntegrationSupportAppleInApp]: false,
  [Feature.ThirdpartyIntegrationSupportAppleInWeb]: false,
};

export const IVS_BASE_CONFIG: Pick<
  FeatureToggleConfig,
  | Feature.IvsIntegration
  | Feature.VerifyPasswordSharedService
  | Feature.IvsSharedService
  | Feature.IvsHideShopeeBranding
> = {
  [Feature.IvsIntegration]: false,
  [Feature.VerifyPasswordSharedService]: false,
  [Feature.IvsSharedService]: false,
  [Feature.IvsHideShopeeBranding]: false,
};

export const TEMPORARY_BASE_CONFIG: Pick<
  FeatureToggleConfig,
  Feature.SendLanguageInSendOtp
> = {
  [Feature.SendLanguageInSendOtp]: false,
};

// TODO: migrate biometrics feature toggle to this group
export const NO_COST_LOGIN_METHOD_BASE_CONFIG: Pick<
  FeatureToggleConfig,
  Feature.QuickLogin | Feature.ReloginPageEntrance
> = {
  [Feature.QuickLogin]: false,
  [Feature.ReloginPageEntrance]: false,
};
